import api from "../../../utilidades/interceptor";

const apiKey = process.env.REACT_APP_API_KEY;

export const getDesconexiones = async (params) => {
    try {
        const response = await api.get(`${apiKey}/seguridad/desconexiones`, { params });
        return response.data;
    } catch (error) {
        console.log("error getDesconexiones", error);
        return [];
    }
};

export const updateObservacionDesconexion = async (data) => {
    try {
        const response = await api.patch(`${apiKey}/seguridad/agregarComentario`, data);
        return response.data;
    } catch (error) {
        console.log("error updateObservacionDesconexion", error);
        throw error;
    }
};

export const marcarSolucionadoDesconexion = async (data) => {
    try {
        const response = await api.patch(`${apiKey}/seguridad/editarSolucionado`, data);
        return response.data;
    } catch (error) {
        console.log("error marcarSolucionadoDesconexion", error);
        throw error;
    }
};
